import * as React from 'react';
import { ScrollCarousel } from '@fastly/consistently';
import styled from 'styled-components';

const ExtendedScrollCarousel = styled(ScrollCarousel)`
  > div {
    margin: 0 -32px;
    padding-bottom: 0;
    align-items: center;
    overflow: hidden;

    &:before {
      content: '';
      position: absolute;
      left: -32px;
      width: 80px;
      height: 80%;
      background: linear-gradient(to right, var(--color-background-light) 27%, rgba(255, 255, 255, 0) 58%);
    }
    &:after {
      content: '';
      position: absolute;
      right: -32px;
      width: 80px;
      height: 80%;
      background: linear-gradient(to left, var(--color-background-light) 27%, rgba(255, 255, 255, 0) 58%);
    }

    > div:first-child {
      padding-left: 33px;
    }
  }

  button {
    &:disabled {
      background: currentColor;
      opacity: 0.2;
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    > div {
      margin: 0 33px;

      > div:first-child {
        padding-left: 0;
      }

      &:before {
        left: 20px;
        width: 50px;
      }

      &:after {
        right: 20px;
        width: 50px;
      }
    }
  }
`;

interface Props {
  itemWidth: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
  gap: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
  rows: {
    sm: number;
    md: number;
    lg: number;
    xl: number;
  };
  navPosition: string;
  navMargin: string;
  renderNavComponent: any;
  children: JSX.Element[];
}

const Carousel = ({
  itemWidth,
  gap,
  rows,
  navPosition,
  navMargin,
  renderNavComponent,
  children,
}: Props): JSX.Element => {
  return (
    <ExtendedScrollCarousel
      itemWidth={itemWidth}
      gap={gap}
      rows={rows}
      navPosition={navPosition}
      navMargin={navMargin}
      renderNavComponent={renderNavComponent}
    >
      {children}
    </ExtendedScrollCarousel>
  );
};

export default Carousel;
